import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { resignationRequestTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import BetterControlledTable from "../../../component/BetterControlledTable";
import {
  approveLeave,
  createLeave,
  getLeaves,
  getTeamLeaves,
} from "../../../api/leaves";
import { CheckCircle, HighlightOff, Summarize } from "@mui/icons-material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import {
  getReginationRequest,
  updateReginationRequest,
} from "../../../api/resignation";

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function ResignationRequestList() {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [emailFilter, setEmailFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [acceptReject, setAcceptReject] = useState("");
  const [noticePeriod, setNoticePeriod] = useState("");
  const [lastWorkingDay, setLastWorkingDay] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [id, setId] = useState("");

  const [selectedYear, setSelectedYear] = useState("");
  addAdditionalColumn(
    obj,
    dispatch,
    user,
    setCreateDialogOpen,
    setNoticePeriod
  );
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`, {
          state: { emp_id: dialogAction.data.emp_id },
        });
        break;
      case "APPROVE":
        dispatch({ type: "" });
        setAcceptReject("True");
        setId(dialogAction.data.id);
        setLastWorkingDay(dialogAction.data.last_working_day);
        setNoticePeriod(dialogAction.data.notice_period_in_days);
        setEmployeeId(dialogAction.data.emp_id);
        setCreateDialogOpen(true);
        break;
      case "REJECT":
        dispatch({ type: "" });
        setAcceptReject("False");
        setId(dialogAction.data.id);
        setEmployeeId(dialogAction.data.emp_id);
        setCreateDialogOpen(true);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  function refreshTable(e) {
    e?.preventDefault();
    setTableRefreshCount((prev) => prev + 1);
  }
  async function getRows(limit, offset) {
    try {
      const { data } = await getReginationRequest(
        {
          limit,
          offset,
          year: selectedYear,
          email: emailFilter,
          status: statusFilter,
          name: nameFilter,
        },
        user.token
      );
      return {
        rows: data.data.records,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    }
  }
  useEffect(() => {
    refreshTable();
  }, [emailFilter, nameFilter, selectedYear, statusFilter]);

  return (
    <Box className="pmt-container-box">
      <Box component="main" sx={{ pb: 1 }}>
        <Typography variant="h1" className="pmt-headings-h1">
          Resignation Request
        </Typography>
      </Box>
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <TextField
            label="Email"
            fullWidth
            variant="outlined"
            className={classes.textfeild}
            value={emailFilter}
            onChange={(e) => setEmailFilter(e.target.value)}
          />
          <Box sx={{ pr: 1 }}></Box>
          <TextField
            label="Name"
            fullWidth
            variant="outlined"
            className={classes.textfeild}
            value={nameFilter}
            onChange={(e) => setNameFilter(e.target.value)}
          />
          <Box sx={{ pr: 1 }}></Box>
          <FormControl fullWidth>
            <InputLabel id="year-label">Status</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <MenuItem value="null">Pending</MenuItem>
              <MenuItem value="true">Accept</MenuItem>
              <MenuItem value="false">Retention</MenuItem>
            </Select>
          </FormControl>
          <Box sx={{ pr: 1 }}></Box>
          <FormControl fullWidth>
            <InputLabel id="year-label">Year</InputLabel>
            <Select
              labelId="year-label"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {Array.from(
                { length: 24 },
                (_, i) => new Date().getFullYear() - i
              ).map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <br />

      <div className="pmt-controll-table">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getRows}
          columns={tableDef}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </div>

      <AcceptRejectResignationDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
        acceptReject={acceptReject}
        noticePeriod={noticePeriod}
        lastWorkingDay={lastWorkingDay}
        employeeId={employeeId}
        id={id}
        disableEscapeKeyDown
      />
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch, user) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      minWidth: 150,
      resizable: true,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellRendererFramework: (params) => (
        <>
          <>
            <IconButton
              color="info"
              title="View Details"
              onClick={() => {
                dispatch({ type: "VIEW", data: params.data });
              }}
            >
              <VisibilityIcon fontSize="inherit" />
            </IconButton>
            {params?.data?.statusdetails === "RESIGNATION_REQUESTED" &&
              user.role === "Admin" && (
                <>
                  <IconButton
                    color="info"
                    title="Accept"
                    onClick={() => {
                      dispatch({ type: "APPROVE", data: params.data });
                    }}
                  >
                    <CheckCircle fontSize="inherit" />
                  </IconButton>
                  <IconButton
                    color="info"
                    title="Retain"
                    onClick={() => {
                      dispatch({ type: "REJECT", data: params.data });
                    }}
                  >
                    <HighlightOff fontSize="inherit" />
                  </IconButton>
                </>
              )}
          </>
        </>
      ),
    });
  }
}

function AcceptRejectResignationDialog({
  open,
  setOpen,
  onRefresh,
  acceptReject,
  lastWorkingDay,
  noticePeriod,
  employeeId,
  id,
}) {
  const emptyData = {
    id: "",
    emp_id: "",
    request_status: "",
    status_remarks: "",
    notice_period_in_days: "",
    last_working_day: "",
    lock_in_date: null,
  };

  const [data, setData] = useState(emptyData);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ emptyData });

  useEffect(() => {
    if (open) {
      setData(emptyData);
    }
  }, [open]);

  useEffect(() => {
    // Calculate the new last working day when notice period changes
    const currentDate = new Date();
    const newLastWorkingDay = new Date(
      currentDate.getTime() + noticePeriod * 24 * 60 * 60 * 1000
    );
    setValue("last_working_day", newLastWorkingDay); // Set the new last working day value
  }, [noticePeriod]);

  async function onAcceptRejectSubmit(data) {
    const newData = { ...data };
    newData.request_status = acceptReject;
    newData.emp_id = employeeId;
    newData.id = id;
    if (acceptReject === "True") {
      if (
        newData.last_working_day === "" ||
        newData.last_working_day === undefined ||
        newData.last_working_day === null
      ) {
        newData.last_working_day = convertToISOFormat(lastWorkingDay);
      }
    } else {
      newData.notice_period_in_days = "0";
      newData.last_working_day = "";
      newData.lock_in_date = createDateAsUTC(newData.lock_in_date);
    }

    try {
      const { data } = await updateReginationRequest(newData, user.token);
      dispatch(showAlert(data.msg));
      setOpen(false);
      onRefresh();
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="md" // Set the maximum width to md (medium)
      sx={{ "& .MuiPaper-root": { width: "100%", maxWidth: "600px" } }}
    >
      {acceptReject === "True" ? (
        <DialogTitle>Accept</DialogTitle>
      ) : (
        <DialogTitle>Retain</DialogTitle>
      )}

      <form onSubmit={handleSubmit(onAcceptRejectSubmit)}>
        <DialogContent>
          <Grid container spacing={2}>
            {acceptReject === "True" ? (
              <>
                <Grid item xs={6}>
                  <TextField
                    name="notice_period_in_days"
                    label="Notice Period (in days)"
                    type="number"
                    required
                    fullWidth
                    defaultValue={noticePeriod}
                    inputRef={register({
                      required: "Notice Period (in days) is required.",
                    })}
                    error={Boolean(errors.notice_period_in_days)}
                    helperText={errors.notice_period_in_days?.message}
                    onChange={(e) => {
                      if (e.target.value === "" || e.target.value === 0) {
                        setValue("last_working_day", null);
                      } else {
                        const newNoticePeriod = parseInt(e.target.value);
                        const currentDate = new Date();
                        const newLastWorkingDay = new Date(
                          currentDate.getTime() +
                            newNoticePeriod * 24 * 60 * 60 * 1000
                        );

                        setValue("last_working_day", newLastWorkingDay);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    fullWidth
                    error={Boolean(errors.last_working_day)}
                  >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Controller
                        render={(props) => (
                          <DesktopDatePicker
                            disabled
                            value={props.value || lastWorkingDay}
                            onChange={(newValue) => {
                              props.onChange(newValue);
                            }}
                            label="Last Working Day"
                            renderInput={(params) => (
                              <TextField
                                error={Boolean(errors.last_working_day)}
                                {...params}
                              />
                            )}
                          />
                        )}
                        rules={{
                          required: false,
                        }}
                        name="last_working_day"
                        control={control}
                      />
                    </LocalizationProvider>
                    <FormHelperText>
                      {errors.last_working_day?.message}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <FormControl fullWidth error={Boolean(errors.lock_in_date)}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Controller
                      render={(props) => (
                        <DesktopDatePicker
                          value={props.value || ""}
                          onChange={(newValue) => {
                            props.onChange(newValue);
                          }}
                          label="Resignation Lock In Date"
                          renderInput={(params) => (
                            <TextField
                              error={Boolean(errors.lock_in_date)}
                              {...params}
                            />
                          )}
                        />
                      )}
                      rules={{
                        required: "Resignation Lock In Date is required.",
                      }}
                      name="lock_in_date"
                      control={control}
                    />
                  </LocalizationProvider>
                  <FormHelperText>
                    {errors.lock_in_date?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                name="status_remarks"
                label="Status Remarks"
                rows={2}
                multiline
                required
                fullWidth
                inputRef={register({
                  required: "Status Remarks is required.",
                })}
                error={Boolean(errors.status_remarks)}
                helperText={errors.status_remarks?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} className="cancel-button">
            Cancel
          </Button>
          <Button className="blue-button" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
function convertToISOFormat(dateString) {
  // Parse the input date string
  const dateObject = new Date(dateString);
  // Check if the dateObject is invalid
  if (isNaN(dateObject.getTime())) {
    return null; // Return null if invalid date
  }
  // Convert to ISO format
  const isoDateString = dateObject.toISOString();
  return isoDateString;
}
function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
}
